import { useQuery, useMutation } from "@1f/react-sdk"
import { query_aziende_byTenant, query_aziende_byNameCfPIva, query_get_allAziende, query_getAziendaById, query_aziendaAddress_primaIdentificazione_byCf } from "../query/aziendaQueries"
import { mutation_add_azienda,mutation_deleteAzienda,mutation_update_azienda } from "../mutations/aziendaMutations";
import {query_user_permission_hasTruePermsCount, query_user_permitted_aziende} from "../query/permissionQueries"
import sharedDatasInstance from "../sharedDatas";

export const AziendaApi = () => {
    const query_aziende_byId = useQuery(
        query_getAziendaById,
        {},
        { lazy: true, graphqlEndpoint: "aml:hasura:api://v1/graphql" }
    )
    const apiAziendeByTenant = useQuery(
        query_aziende_byTenant,
        {},
        { lazy: true, graphqlEndpoint: "aml:hasura:api://v1/graphql" }
    );
    const apiAziendeByNameCfPIva = useQuery(
        query_aziende_byNameCfPIva,
        {},
        { lazy: true, graphqlEndpoint: "aml:hasura:api://v1/graphql" }
    );
    const apiUserHasTruePermsCount = useQuery(
        query_user_permission_hasTruePermsCount,
        {},
        { lazy: true, graphqlEndpoint: "aml:hasura:api://v1/graphql" }
    );
    const apiUserPermittedAziende = useQuery(
        query_user_permitted_aziende,
        {},
        { lazy: true, graphqlEndpoint: "aml:hasura:api://v1/graphql" }
    );
    const getAllAziendeQuery = useQuery(
        query_get_allAziende,
        {},
        { lazy: true, graphqlEndpoint: "aml:hasura:api://v1/graphql" }
    );
    const apiAziendaAddressPrimaIdentificazioneByCf = useQuery(
        query_aziendaAddress_primaIdentificazione_byCf,
        {},
        { lazy: true, graphqlEndpoint: "aml:hasura:api://v1/graphql" }
    );
    const apiAddAzienda = useMutation(mutation_add_azienda, {
        graphqlEndpoint: "aml:hasura:api://v1/graphql",
    });
    const apiUpdateAzienda = useMutation(mutation_update_azienda, {
        graphqlEndpoint: "aml:hasura:api://v1/graphql",
    });
    const apiDeleteAziende = useMutation(mutation_deleteAzienda, {
        graphqlEndpoint: "aml:hasura:api://v1/graphql",
    });

    const GetAziendaById = async (aziendaId, tenantId) => {
        try {
            let aziendaResponse = await query_aziende_byId.fetch({
                id: aziendaId,
                tenantId : tenantId
            });
            if(aziendaResponse){
                return aziendaResponse.data.data.getAziendaById;
            }
        } catch (error) {
            throw new Error("Impossibile recuperare l'azienda con ID " + aziendaId + ": " + error.message);
        }
    }
    const GetAziendeByTenant = async (tenantId) => {
        try{
            let aziendeResponse = await apiAziendeByTenant.fetch({
                tenantId: tenantId
            })
            if(aziendeResponse){
                return aziendeResponse.data.data.azienda;
            }
        } catch (error){
            throw new Error("Impossibile recuperare le aziende del tenant " + tenantId + ": " + error.message)
        }
    }
    const GetAllAziende = async (tenantId) => {
        try {
            let aziendeResponse = await getAllAziendeQuery.fetch({
                tenantId: tenantId
            });
            if(aziendeResponse){
                return aziendeResponse.data.data.getAllAziende;
            }
        } catch (error) {
            throw new Error("Impossibile recuperare tutte le aziende del tenant " + tenantId + ": " + error.message)
        }
    }
    const GetAziendeByNameCfPIva = async (tenantId, tenantModel) => {
        try {
            let aziendeResponse = await apiAziendeByNameCfPIva.fetch({
                tenantId: tenantId,
                denominazione: tenantModel.name,
                cf: tenantModel.vatNumber,
                pIva: tenantModel.vatNumber,
            });
            if(aziendeResponse){
                return aziendeResponse.data.data.azienda;
            }
        } catch (error) {
            throw new Error("Impossibile recuperare le aziende per il tenant " + tenantId + ": " + error.message)
        }
    }
    const CheckAziendaPermissions = async (aziendaId, userId) => {
        try {
            let permissionsResponse = await apiUserHasTruePermsCount.fetch({
                userId: userId,
                aziendaId: aziendaId,
            });
            if(permissionsResponse){
                return permissionsResponse.data.data.user_permission_aggregate.aggregate.count > 0;
            }
        } catch (error) {
            throw new Error("Impossibile verificare i permessi sull'azienda " + aziendaId + " per l'utente " + userId + ": " + error.message)
        }
    }
    // Ritorna un Set<number> con le AziendaId su cui l'utente ha almeno un permesso attivo.
    // Una sola fetch (elimina l'N+1 di CheckAziendaPermissions). Il filtro tenant è garantito
    // a monte intersecando con le aziende del tenant (user_permission non ha colonna tenant).
    const GetUserPermittedAziendaIds = async (userId) => {
        try {
            let permittedResponse = await apiUserPermittedAziende.fetch({
                userId: userId,
            });
            if(permittedResponse){
                return new Set(permittedResponse.data.data.user_permission.map((p) => p.AziendaId));
            }
            return new Set();
        } catch (error) {
            throw new Error("Impossibile recuperare le aziende su cui l'utente " + userId + " ha permessi: " + error.message)
        }
    }
    const PostAzienda = async (aziendaData,tenantId) => {
        try {
            let aziendaAddResponse =  await apiAddAzienda.fetch({
                tenantId: tenantId,
                denominazione: aziendaData.denominazione,
                cf: aziendaData.cf,
                pIva: aziendaData.pIva,
                addrPaeseId: aziendaData.addrPaeseId,
                addrProvinciaId: aziendaData.addrProvinciaId,
                addrProvincia: aziendaData.addrProvincia,
                addrComuneId: aziendaData.addrComuneId,
                addrComune: aziendaData.addrComune,
                addrIndirizzo: aziendaData.addrIndirizzo,
                addrN: aziendaData.addrN,
                addrCap: aziendaData.addrCap,
            });
            if(aziendaAddResponse){
                return aziendaAddResponse.data.data.insert_azienda_one;
            }
        } catch (error) {
            throw new Error("Impossibile aggiungere l'azienda " + aziendaData.denominazione + " del tenant " + tenantId + ": " + error.message);
        }
    }
    const UpdateAzienda = async(aziendaData) => {
        try {
            let updateAziendaResponse = await apiUpdateAzienda.fetch({
                id: aziendaData.id,
                cf: aziendaData.cf,
                pIva: aziendaData.pIva,
                denominazione: aziendaData.denominazione,
                addrPaeseId: aziendaData.addrPaeseId,
                addrProvinciaId: aziendaData.addrProvinciaId,
                addrProvincia: aziendaData.addrProvincia,
                addrComuneId: aziendaData.addrComuneId,
                addrComune: aziendaData.addrComune,
                addrIndirizzo: aziendaData.addrIndirizzo,
                addrN: aziendaData.addrN,
                addrCap: aziendaData.addrCap,
                meteringSlotId: aziendaData.meteringSlotId,
            });
            if(updateAziendaResponse){
                return updateAziendaResponse.data.data.update_azienda.returning[0];
            }
        } catch (error) {
            throw new Error("Impossibile aggiornare l'azienda " + aziendaData.denominazione + ": " + error.message);
        }
    }
    const DeleteAzienda = async (aziendaId,tenantId) => {
        try {
            let deleteAziendaResponse = await apiDeleteAziende.fetch({
                id: aziendaId,
                tenantId: tenantId,
            });
            if(deleteAziendaResponse){
                return deleteAziendaResponse.data.data.deleteAzienda;
            }
        } catch (error) {
            throw new Error("Impossibile eliminare l'azienda " + aziendaId + " del tenant " + tenantId + ": " + error.message);
        }
    }
    const formatAziendaAddress = (azienda, provinciaLookup = null) => {
        if (!azienda) {
            return "";
        }
        //Gestisco sia la forma GraphQL (PascalCase) che il modello azienda (camelCase)
        const comune = azienda.AddrComune ?? azienda.addrComune ?? "";
        const indirizzo = azienda.AddrIndirizzo ?? azienda.addrIndirizzo ?? "";
        const n = azienda.AddrN ?? azienda.addrN ?? "";
        const cap = azienda.AddrCap ?? azienda.addrCap ?? "";
        //Per gli indirizzi italiani la provincia è referenziata da AddrProvinciaId (la sigla è su
        //base_provincia); il campo testuale AddrProvincia è valorizzato solo per gli indirizzi esteri.
        let provincia = azienda.AddrProvincia ?? azienda.addrProvincia ?? "";
        if (!provincia && provinciaLookup) {
            const provinciaId = azienda.AddrProvinciaId ?? azienda.addrProvinciaId ?? null;
            if (provinciaId !== null && provinciaId !== undefined) {
                provincia =
                    (provinciaLookup instanceof Map
                        ? provinciaLookup.get(provinciaId)
                        : provinciaLookup[provinciaId]) ?? "";
            }
        }
        return comune + " " + indirizzo + ", " + n + " " + cap + " (" + provincia + ")";
    }
    const GetPrimaIdentificazioneByCf = async (cf, tenantId = sharedDatasInstance.getPropertyByName("tenantId"), provinciaLookup = null) => {
        if (cf === undefined || cf === null || cf === "") {
            return null;
        }
        try {
            let primaIdentResponse = await apiAziendaAddressPrimaIdentificazioneByCf.fetch({
                cf: cf,
                tenantId: tenantId,
            });
            let anagrafiche = primaIdentResponse?.data?.data?.anagrafica;
            if (!anagrafiche || anagrafiche.length === 0) {
                return null;
            }
            const primaIdent = anagrafiche[0];
            const azienda = primaIdent.anagrafica_fascicolos[0]?.fascicolo?.azienda ?? null;
            return {
                identifiedByUser: primaIdent.IdentifiedByUser,
                identifiedOn: primaIdent.IdentifiedOn,
                address: azienda ? formatAziendaAddress(azienda, provinciaLookup) : null,
            };
        } catch (error) {
            throw new Error("Impossibile recuperare la prima identificazione per il codice fiscale " + cf + ": " + error.message);
        }
    }

    return {
        GetAziendaById,
        GetAziendeByTenant,
        GetAllAziende,
        GetAziendeByNameCfPIva,
        CheckAziendaPermissions,
        GetUserPermittedAziendaIds,
        PostAzienda,
        UpdateAzienda,
        DeleteAzienda,
        GetPrimaIdentificazioneByCf,
        formatAziendaAddress
    }
}
